import type {PlaceId} from '@jetbrains/teamcity-api'

import type {State} from '../../../reducers/types'
import {emptyArray} from '../../../utils/empty'

export const getCachedPlugins: (arg0: State, arg1: PlaceId) => ReadonlyArray<string> = (
  state,
  placeId,
) => state.cachedPlugins[placeId] ?? emptyArray
